import { MAIN_DOMAIN, WEB_SERVER_HOST } from "@/environment/index";
import { createEcho } from "@/plugins/echo";
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import moment from "moment";
import * as axios from "@/services/Axios";
import {
  _asCardPayment,
  _asCashPayment,
  _getReceipt
} from "@/services/Payment";
// import { _editBooking } from "@/services/Booking";
import { _recordAnalytics } from "@/services/analytics";

window.Echo = createEcho({
  host: WEB_SERVER_HOST,
  authEndpoint: "/broadcasting/auth",
});

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

export default {
  components: {
    Datepicker,
    vSelect
  },
  data() {
    return {
      vehicleOptions: [
        {
          label: 'Standard',
          id : -1
        },
        {
          label: '6 Seater',
          id : 1
        },
        {
          label: '8 Seater',
          id : 3
        }
      ],

      // bookingEditableFields:{
      //   date: { value: null, visible: true },
      //   time: { value: null, visible: true },
      //   pickup: { value: null, lat: null, lng:null, visible: true },
      //   dropOff: { value: null, lat: null, lng:null, visible: true },
      //   vehicleType: { value: {id:'',value: ''}, visible: true },
      //   name: { value: null, visible: true },
      //   driverNotes: { value: null, visible: true }
      // },
      // editBookingPopup:false,
      current_company: null,
      charityDescriptionPopup: false,
      postUrl: null,
      reference: null,

      amount: 0,
      pickup: "",
      destination: "",
      bid: null,
      booking_found: false,
      is_archived: false,
      checkezp: false,
      checkaccount: false,

      payment_type: null,

      pay_by_card_screen: true,
      variable_cost: false,
      pay_reference: "",

      is_dispatched: false,
      is_fixed_price: false,
      is_as_directed: false,
      amount_type: "Fixed",

      payment_done_case: false,

      bookingStatus: "",
      got_variable_price: false,
      is_locked: false,

      is_manual_booking: null,
      allow_manual_booking: null,
      manually_allowed_check: null,
      phonenumber: null,

      authcode: null,
      decryptedBookingId: null,
      bookingPickupTime: null,
      driverCallsign: null,

      ghostBooking: null,
      admin_allow_third_party: null,
      quoteData: null,
      booking_type: null,

      showCharityDiv: false,
      charityText: "",
      charityDescription: "",
      payForCharity: false,
      charityAmount: 0.0,
      newAmount: 0.0,
      beforeCharityAmount: 0,
      companyLogo: null,

      isAndroid: false,
      isIphone: false,
      isWindows: false,
      isMac:false,
      email: null,
      paidPaymentReference: null,
      bookingPaymentAmount: null,
      systemId: null,
      showTracking: false,
      showEditing: false,
      disabledDates: {
        to: null
      },
      // _editableDate:null,
      selectedVehicle: null,
      payment_status: null,
      timeMin: null,
      company_number: null,
      provider: null,
      cashMeterJob: false,
      manuallyFixedPriceJob: false,
      accountBookingText: 'The following booking is on an invoiced account and cannot be changed into a non account booking',
    };
  },
  watch: {
    payForCharity(val) {
      if (val) {
        this.calculateAmountWithCharity();
        this.prepaycall(true);
      } else {
        this.amount = this.beforeCharityAmount;
        this.charityAmount = 0.0;
        this.prepaycall();
      }
    },
    cashMeterJob(val) {
      // Autocab-specific handling
      if (val) {
        this.accountBookingText = "The following booking is on cash meter job. Not allowed in this version of Autocab";
      }
    },
    // 'bookingEditableFields.date.value': function () {
    //   this.updateTimeMin();
    // }
  },
  mounted() {
    document.title = "NUDG Web Application";
    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href =  `${process.env.BASE_URL}nudgpay-favicon.ico`;
    }
    this.detectDevice();
    // this.updateTimeMin();
  },
  props: {
    bookingData: {
      type: Object,
      required: true
    }
  },
  beforeMount() {
    document.documentElement.style.overflow = "hidden";
    // Loader is already shown by wrapper component
    this.bid = this.$route.params.bid;
    this.loadBookingData();
  },
  methods: {
    loadBookingData() {
      // Use booking data passed from parent component instead of making API call
      const res = { data: { obj: this.bookingData } };
      
      this.decryptedBookingId = res.data.obj.decrypt_booking_id;
      this.current_company = res.data.obj.company_id;
      this.systemId = res.data.obj.system_id;
      this.provider = res.data.obj.booking_provider;
      this.checkezp = res.data.obj.checkezp;
      this.payment_status = res.data.obj.payment_status;

      if (this.checkezp || this.payment_status == 'paid') this.payment_done_case = true;
      
      if (this.checkezp && this.payment_status !== 'paid') {
        this.$vs.notify({
          title: "Alert",
          text: "This booking is an EZP booking and payment is not completed.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }
      if (!this.checkezp && this.payment_status === 'paid') {
        this.$vs.notify({
          title: "Notice",
          text: "Booking payment marked as paid locally, but is not updated in Ghost system.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }

      this.setSystemSpecificFeatures();
      this.company_number = res.data.obj.company_number ? res.data.obj.company_number : '1159500500';
     
      this.listen();
      this.listenForAnyChange();
      this.companyLogo = res.data.obj.company_logo
        ? MAIN_DOMAIN + res.data.obj.company_logo
        : null;
      this.showCharityDiv = res.data.obj.is_charity_enable;
      this.booking_type = res.data.obj.booking.bookingType;
      this.admin_allow_third_party = res.data.obj.admin_allow_third_party;
      console.log(res.data.obj.getquotedata.error);
      if(res.data.obj.getquotedata.body && res.data.obj.getquotedata.body.quotes && res.data.obj.getquotedata.body.quotes.length > 0) {
        this.quoteData = res.data.obj.getquotedata.body.quotes[0];
      } else {
        this.$vs.notify({
          title: "Quote Error: " + res.data.obj.getquotedata.message,
          text: res.data.obj.getquotedata.warnings,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
        this.quoteData = null;
        return;
      }
      this.ghostBooking = res.data.obj.booking;

      // this.setBookingEditableFields(this.ghostBooking);
      this.pickup = res.data.obj.pickup;
      this.destination = res.data.obj.destination;
      this.checkaccount = res.data.obj.checkaccount;

      // Autocab-specific initialization
      this.initializeProviderSpecificData(res.data.obj);

      this.paidPaymentReference = res.data.obj.payment;

      this.is_as_directed = res.data.obj.is_as_directed;
      this.is_dispatched = res.data.obj.is_dispatched;
      this.is_fixed_price = res.data.obj.is_fixed_price;
      this.amount = res.data.obj.price;
      this.is_archived = res.data.obj.is_archived;
      this.pay_reference = res.data.obj.payment_ref;
      this.bookingStatus = res.data.obj.booking_status;
      this.payment_type = res.data.obj.payment_type;
      if (this.payment_type == "CASH"  || this.payment_type == "CARD") {
        this.payment_type = "Card";
      }
      this.booking_found = true;
      this.variable_cost = res.data.obj.variable_cost;
      this.is_locked = res.data.obj.is_locked;
      this.is_manual_booking = res.data.obj.is_manual_booking;
      this.allow_manual_booking = res.data.obj.allow_manual_booking;
      this.phonenumber = res.data.obj.cust_ref;
      this.bookingPaymentAmount = res.data.obj.payment_amount;

      if (this.admin_allow_third_party) {
        if (
          (!this.checkezp &&
            this.is_fixed_price &&
            this.payment_type == "Card") ||
          this.payment_type == "Card" ||
          ((this.bookingStatus == "active" || this.bookingStatus == "booked" || this.bookingStatus == "offered") &&
            this.is_fixed_price)
        ) {
          if (!this.is_archived && this.is_locked && !this.is_fixed_price)
            this.prepaycall();
          else if (!this.is_archived && this.is_fixed_price) this.prepaycall();

          else if (!this.is_archived && (this.bookingStatus == 'booked' || this.bookingStatus == 'offered') && !this.payment_done_case ) {
            this.prepaycall();
          }
        }
      } else {
        if (!this.checkezp && !this.is_archived) this.prepaycall();
      }

      if (this.is_manual_booking) {
        this.manually_allowed_check = this.allow_manual_booking
          ? true
          : false;
      } else {
        this.manually_allowed_check = true;
      }

      this.authcode = res.data.obj.authcode;
      this.bookingPickupTime = res.data.obj.booking_pickup_due_time;
      this.driverCallsign = res.data.obj.driver_callsign;
      this.admin_allow_third_party = res.data.obj.admin_allow_third_party;
    
      this.charityText = res.data.obj.charity
        ? res.data.obj.charity.title
        : "";
      this.charityDescription = res.data.obj.charity
        ? res.data.obj.charity.description
        : "";

    // this.setVehicleType(this.ghostBooking.capabilities)
     const today = new Date();
      today.setHours(0, 0, 0, 0);
      this.disabledDates.to = today;
      // this.setFieldEditability();
      this.$vs.loading.close();
      this.$nextTick(() => {
        this.setPickupPlace(this.pickup);
        this.setDropoffPlace(this.destination);
      });
    },
    setSystemSpecificFeatures() {
      const features = (this.bookingData && this.bookingData.features) || [];
      this.showTracking = features.includes('nudgpay_tracking');
      this.showEditing = features.includes('nudgpay_editing');
    },
    getUkTimeString() {
      const now = new Date();
      const ukTimeString = now.toLocaleString('en-GB', { 
        timeZone: 'Europe/London',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      return ukTimeString;
    },
    // updateTimeMin() {
    //   const nowUkStr = this.getUkTimeString();
    //    const selected = this.bookingEditableFields.date.value;
      
    //   if (!selected) {
    //     this.timeMin = nowUkStr;
    //     return;
    //   }
      
    //   const today = new Date();
    //   const selectedDate = new Date(selected);
      
    //   const isToday = today.getFullYear() === selectedDate.getFullYear() &&
    //                   today.getMonth() === selectedDate.getMonth() &&
    //                   today.getDate() === selectedDate.getDate();
      
    //   this.timeMin = isToday ? nowUkStr : null;
    // },
    async handleSubmit() {
      await this.$nextTick();

      const form = this.$refs.paymentForm;
      if (!form) {
        console.error('Form not found');
        return;
      }
      try {
        await _recordAnalytics({
          booking_id: this.decryptedBookingId,
          button_type: 'pay_now',
          system_id: this.systemId
        });

        form.submit();

      } catch (error) {
        console.error('Error tracking Pay Now button:', error);
      }
    },
    onInputChange(selectedDate){
      const date = new Date(selectedDate);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      this._editableDate = `${year}-${month}-${day}`;
      return this._editableDate;
    },
    reloadPage(){
       window.location.reload();
    },
    // editBooking() {
    //   this.$vs.loading({ text: "Saving modifications...." });

    //   this.bookingEditableFields.vehicleType.value =  this.selectedVehicle
    //   const apiPayload = Object.fromEntries(
    //     Object.entries(this.bookingEditableFields).map(([key, field]) => [key, field.value])
    //   );
      

    //   _editBooking(this.decryptedBookingId, editData).then(
    //   (res) => {
    //     if(!res.data.obj.status_changed) {
    //       this.$vs.notify({ color: '#79E864', title: 'Modified Success', text: 'Booking has been modified' })
    //       this.$vs.loading.close();
    //     }
    //     else {
    //       this.$vs.notify({ color: '#79E864', title: 'Modified Success', text: 'Booking status mismatched. You need to refresh ' })
    //       this.$vs.loading.close();
    //       }
    //   },
    //   (error) => {
    //     this.$vs.loading.close();
    //     console.log(error.response.data);
    //     this.$vs.notify({
    //       title: "Error",
    //       text: error.response.data.responseMessage,
    //       iconPack: "feather",
    //       icon: "icon-cross-circle",
    //       color: "danger",
    //     });
    //   }
    // );
    // },
    capitalizeFirst(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    setPickupPlace(val) {
      if (this.$refs.pickupAutocomplete && this.$refs.pickupAutocomplete.$refs && this.$refs.pickupAutocomplete.$refs.input) {
        this.$refs.pickupAutocomplete.$refs.input.value = val;
      }
    },
    setDropoffPlace(val) {
      if (this.$refs.dropoffAutocomplete && this.$refs.dropoffAutocomplete.$refs && this.$refs.dropoffAutocomplete.$refs.input) {
        this.$refs.dropoffAutocomplete.$refs.input.value = val;
      }
    },
    // setFieldEditability() {
    //   if (!this.showEditing) {
    //     return;
    //   }
    //   if(this.payment_done_case || this.manuallyFixedPriceJob) {
    //     this.bookingEditableFields.date.visible = false;
    //     this.bookingEditableFields.time.visible = false;
    //     this.bookingEditableFields.pickup.visible = false;
    //     this.bookingEditableFields.dropOff.visible = false;
    //   }
    //   else {
    //     if(this.bookingStatus == 'archived' || this.bookingStatus == 'complete' || this.bookingStatus == 'completed ' || this.bookingStatus == 'cancelled') {
    //       this.bookingEditableFields.date.visible = false;
    //       this.bookingEditableFields.time.visible = false;
    //       this.bookingEditableFields.pickup.visible = false;
    //       this.bookingEditableFields.dropOff.visible = false;
    //       this.bookingEditableFields.name.visible = false;
    //       this.bookingEditableFields.driverNotes.visible = false;
    //       this.editBookingPopup = false;
    //       this.showEditing = false;
    //     }
    //     else {
    //       if (this.bookingStatus == 'dispatched' || this.bookingStatus == 'arrived' || this.bookingStatus == 'pickedup') {
    //           this.bookingEditableFields.date.visible = false;
    //           this.bookingEditableFields.time.visible = false;
    //           this.bookingEditableFields.pickup.visible = false;
    //           // Autocab-specific logic for dropOff visibility
    //           this.setDropOffEditability();
    //       }
    //       else {
    //           this.bookingEditableFields.date.visible = true;
    //           this.bookingEditableFields.time.visible = true;
    //           this.bookingEditableFields.pickup.visible = true;
    //           this.bookingEditableFields.dropOff.visible = true;
    //         }
    //     }
    //   }
    // },
    convertToDate(dateString) {
      const [day, month, year] = dateString.split('/');
      const formattedDateString = [year, month, day].join('-');
      return new Date(formattedDateString);
    },
    // setBookingEditableFields(booking) {
    //   const utcTime = booking.pickupDueTimeUtc;
    //   const dateObj = new Date(utcTime);

    //   const options = {
    //     hour: '2-digit',
    //     minute: '2-digit',
    //     hour12: false,
    //     timeZone: 'Europe/London',
    //   };

    //   const formattedTime = dateObj.toLocaleTimeString('en-GB', options);
    //   const formattedDate = dateObj.toLocaleDateString('en-GB', {
    //     day: '2-digit',
    //     month: 'short',
    //     year: 'numeric',
    //     timeZone: 'Europe/London',
    //   });

    //   this.bookingEditableFields.date.value = formattedDate;
    //   this.bookingEditableFields.time.value = formattedTime;
    //   this.bookingEditableFields.pickup.value = booking.pickup.address.text;
    //   this.bookingEditableFields.pickup.lat = booking.pickup.address.coordinate.latitude;
    //   this.bookingEditableFields.pickup.lng = booking.pickup.address.coordinate.longitude;
    //   this.bookingEditableFields.dropOff.value = booking.destination.address.text;
    //   this.bookingEditableFields.dropOff.lat = booking.destination.address.coordinate.latitude;
    //   this.bookingEditableFields.dropOff.lng = booking.destination.address.coordinate.longitude;
    //   this.bookingEditableFields.name.value = booking.name;
    //   this.bookingEditableFields.driverNotes.value = booking.driverNote;

    //   document.querySelectorAll('.pac-container').forEach((el) => {
    //     el.style.zIndex = '900000';
    //   });
    // },
    setVehicleType(capabilities) {
      console.log(capabilities.length );
      if (capabilities.length == 0 ) {
          this.selectedVehicle = this.vehicleOptions[0]
          return;
      }
      else {
        switch (capabilities[0]) {
          case 1:
            this.selectedVehicle = this.vehicleOptions[1]
            break;
          case 3:
            this.selectedVehicle = this.vehicleOptions[2]
            break;

          default:
            break;
        }
      }
    },
    // editClick() {
    //   _recordAnalytics({
    //     'booking_id' : (this.decryptedBookingId).toString(),
    //     'button_type' : 'edit',
    //     'system_id' : this.systemId
    //     }).then(
    //     (res) => {
    //       this.editBookingPopup = true;
    //       this.$nextTick(() => {
    //         this.setFieldEditability();
    //       });
    //     });
    // },
    callUs() {
      window.location.href = 'tel:+44' + this.company_number;
    },
    async redirectToDownloadPage() {
      try {
        await _recordAnalytics({
              'booking_id' : (this.decryptedBookingId).toString(),
              'button_type' : 'download',
              'system_id' : this.systemId
          }).then((res)=> {
            console.log(res);
          });
          if (this.isAndroid || this.isWindows) {
            const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.dggroup.nudg.user.app&hl=en_US';
            window.location.href = playStoreUrl;
          } else if (this.isIphone || this.isMac) {
            const appleStoreUrl = 'https://apps.apple.com/gb/app/nudg-fast-safe-taxi-booking/id1618819793';
            window.location.href = appleStoreUrl;
          } else {
            console.log('what type of device is this ??');
          }
        } catch (error) {
        }
    },
    redirectToLiveTrackingPage() {
      _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : 'tracking',
        'system_id' : this.systemId
      }).then(
      (res) => {
        this.$router.push({ name: 'LiveTracking' });
      });
    },
    logAnalytic(btnType) {
       _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : btnType,
        'system_id' : this.systemId
      }).then(
      (res) => {
        console.log(res)
      });
    },
    detectDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        this.isAndroid = true;
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.isIphone = true;
      }

      if (/windows phone/i.test(userAgent) || /win/i.test(userAgent)) {
        this.isWindows = true;
      }

       if (/macintosh|mac os x/i.test(userAgent)) {
        this.isMac = true;
      }
    },
    payByCard() {
      _asCardPayment({ bid: this.bid }).then(
        (res) => {
          if (res.data.obj.errorCode == "0") {
            if (this.is_fixed_price) {
              this.prepaycall();
            } else {
              if (this.is_locked) {
                this.prepaycall();
              }
            }
            this.payment_type = "Card";
          }
        },
        (error) => {
          if (
            error.response.data.errors.errorCode == "3" ||
            error.response.data.errors.errorCode == "4"
          ) {
            this.bookingStatus = "archived";
            this.is_archived = true;
          }
          console.log(error.response.data.errors.errorCode);
        }
      );
    },
    payCash() {
      _asCashPayment({ bid: this.bid }).then(() => {
        this.payment_type = "Cash";
      });
    },
    listenForAnyChange() {
     window.Echo.channel(`booking.${this.decryptedBookingId}`).listen(
        "GeneralBookingEvent",
          (e) => {
          console.log(e);
          if(this.cashMeterJob) {
            this.accountBookingText = "The following booking is on cash meter job. Not allowed in this version of Autocab";
          }
          if(e.request_payload.EventType == 'BookingModified') {
            if(e.change_type == 'cost_modified')
              window.location.reload();
          }
          else if(e.change_type == 'booking_status') {
            if (e.request_payload && 'BookingStatus' in e.request_payload) {
              this.bookingStatus = e.request_payload.BookingStatus;
              console.log('BookingStatus exists:', e.request_payload.BookingStatus);
              // this.setFieldEditability();
              if(e.request_payload.BookingStatus == 'cancelled' || e.request_payload.BookingStatus == 'complete') {
                this.bookingStatus = 'archived';
                // this.editBookingPopup = false;
                // this.showEditing = false;
              }
            }
          }
        });
    },
    listen() {
      window.Echo.channel(`meter-shout-booking-${this.bid}`).listen(
        "TaxiMeterShout",
        (e) => {
          if (this.admin_allow_third_party) {
            if (e.message == "vehicleDispatchEvent") {
              this.is_dispatched = true;
              this.bookingStatus = "pickedup";
            } else if (e.message == "variableBooking") {
              this.is_dispatched = true;
              this.bookingStatus = "pickedup";
              this.amount = null;
              this.amount_type = "Variable";
            } else {
              this.amount_type = "Variable";
              this.amount = e.data;
            }
            if (!this.is_locked && this.payment_type == "Card") {
              this.is_locked = true;
              this.prepaycall();
            }
          }
        }
      );
    },
    payNow() {
      _recordAnalytics({
        'booking_id' : (this.decryptedBookingId).toString(),
        'button_type' : 'pay_now',
        'system_id' : this.systemId
      }).then(
        (res) => {
          this.$refs.pay.submit();
        });
    },
    prepaycall(charity = false) {
      if(this.payment_done_case)
        return;
      if(this.checkaccount)
        return;
      if (this.admin_allow_third_party) {
        if (this.is_fixed_price) this.amount = this.amount;
        else this.amount = this.amount ? this.amount : 0.0;
      } else {
        if (!this.is_manual_booking) {
          this.amount = this.quoteData.price.price;
        }
      }
      if (charity) {
        this.amount = this.newAmount;
      }
      const data = {
        bid: this.bid,
        price: this.amount,
        charityAmount: Number(this.charityAmount),
        actualBookingPrice: this.amount - this.charityAmount,
        pickup: this.pickup,
        destination: this.destination,
        cust_reference: this.phonenumber
          ? this.phonenumber
          : Math.random().toString(36).substring(2, 7),
        pay_reference: this.pay_reference,
      };
      axios.post(`booking/pay`, data).then(
        (resp) => {
          this.postUrl = resp.data.postUrl;
          this.reference = resp.data.reference;
        },
        (error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseMessage,
            text: error.response.data.errors.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        }
      );
    },
    calculateAmountWithCharity() {
      var newAmount;
      if (Number.isInteger(this.amount)) newAmount = this.amount + 1;
      else newAmount = Math.ceil(this.amount);
      this.charityAmount = parseFloat(newAmount - this.amount).toFixed(2);
      this.newAmount = newAmount;
      return parseFloat(newAmount - this.amount).toFixed(2);
    },
    openCharityDescription() {
      if (!this.payForCharity) this.calculateAmountWithCharity();
      this.charityDescriptionPopup = true;
    },
    getReciept() {
      if (!this.email) alert("Please enter valid email to get receipt");
      _getReceipt({ email: this.email }, this.paidPaymentReference).then(
        (res) => {
          alert('email has been sent to your given address');
          this.email ='';
          console.log(res);
        }
      );
    },
    // Autocab-specific methods
    initializeProviderSpecificData(bookingData) {
      // Autocab-specific initialization if needed
      // Default behavior - can be overridden
    },
    // setDropOffEditability() {
    //   // Autocab uses default behavior - dropOff is always visible when pickup is not
    //   this.bookingEditableFields.dropOff.visible = true;
    // },
    formatPlaceAddress(place) {
      // Autocab uses default formatted_address
      if (!place || !place.formatted_address) {
        return '';
      }
      return place.formatted_address;
    },
    // setPlace(place) {
    //   // Autocab uses default place setting (formatted_address)
    //   this.bookingEditableFields.pickup.value = place.formatted_address;
    //   this.bookingEditableFields.pickup.lat = place.geometry.location.lat();
    //   this.bookingEditableFields.pickup.lng = place.geometry.location.lng();
    // },
    // setPlace2(place) {
    //   // Autocab uses default place setting (formatted_address)
    //   this.bookingEditableFields.dropOff.value = place.formatted_address;
    //   this.bookingEditableFields.dropOff.lat = place.geometry.location.lat();
    //   this.bookingEditableFields.dropOff.lng = place.geometry.location.lng();
    // },
  }
};

